import React from 'react';

import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { Route, Redirect } from 'react-router-dom';
import SplitContainer from '@zippytech/react-toolkit/SplitContainer'
import '@zippytech/react-toolkit/SplitContainer/index.css'
import ReactResizeDetector from 'react-resize-detector';

import ResourcePaneIndex from "./ResourcesPane";
import InitiativeTree from "./BrowserPane/InitiativeTree";
import DesignerIndex from './DesignerPane/CardIndex'
import { HelpComponent } from "../../common/HelpComponent";


import SelectePlaybook from './DesignerPane/CreateInitiative/SelectPlaybook'
import BasicInfo from './DesignerPane/CreateInitiative/BasicInfo'
import TeamMapping from './DesignerPane/CreateInitiative/TeamMapping'
import ConfigureActivity from './DesignerPane/CreateInitiative/ConfigureActivity'
import Integration from './DesignerPane/CreateInitiative/Integration'
import Finalize from './DesignerPane/CreateInitiative/Finalize'
import Review from './DesignerPane/CreateInitiative/Review'
import AddAdditionalInfo from './DesignerPane/CreateInitiative/AddAdditionalInfo'

import Progress from './DesignerPane/ActiveInitiative/Progress'
import Sequence from './DesignerPane/ActiveInitiative/Sequence'
import Teams from './DesignerPane/ActiveInitiative/Teams'
import Timeline from './DesignerPane/ActiveInitiative/Timeline'
import AdditioanlInformation from './DesignerPane/ActiveInitiative/AdditioanlInformation'

import './initiative.css'
import LoadingComponent from '../../common/LoadingComponent';
import { push } from "react-router-redux";
import ServeyMetaDataForm from './DesignerPane/CreateInitiative/ServeyMetaDataForm';

class Initiatives extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            splitAt: "-40%",
            browserPaneSplit: "25%",
            collapsedResourcePaneIndex: null
        }
    }

    componentWillMount() {
        if (this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'Member') {
            return dispatch(push(`/app/${this.props.match.params.accountId}/403`));
        }
        else {
            dispatch.initiatives.getinitiativesCount({ organizationId: this.props.selectedOrganisation.id });
            dispatch.app.setCurrentContext("initiative");
            dispatch.initiatives.setPageStatus(null);
            dispatch.initiatives.setTabName(null);
            dispatch.initiatives.setInitiativeId(null);
        }
        dispatch.app.setRouteParams(this.props.match.params);
        dispatch.initiatives.isSortingFlag({ key: "subCategory", order: -1 ,text:"Sub Category"});
    }
    componentWillUnmount() {
        this.endFun()
    }
    async endFun() {
        await dispatch.initiatives.showResourecePane(null);
        await dispatch.initiatives.setSelectedActivityData({});
    }

    onResize = (width, height) => {
        let windowHeight = window.innerHeight
        let designerDimension = {
            width: width,
            windowHeight: windowHeight,
            height: height
        }
        dispatch.initiatives.setDesignerDimension(designerDimension)


        const setUniqueId = this.props.setUniqueId;
        if (setUniqueId) {
            const initiativeCardElement = document.getElementById(setUniqueId);
            if (initiativeCardElement) {
                setTimeout(() => {
                    initiativeCardElement.scrollIntoView({ block: "center", inline: "nearest" });
                }, 100);
            }
        }
    }


    keyPress = async (e) => {
        let selectedDataByIdObj = Object.entries(this.props.selectedDataById).length !== 0 && this.props.selectedDataById.constructor === Object
        let selectedPlaybookData = Object.entries(this.props.selectedPlaybookData).length !== 0 && this.props.selectedPlaybookData.constructor === Object
        let selectedActivityDataObj = Object.entries(this.props.selectedActivityData).length !== 0 && this.props.selectedActivityData.constructor === Object
        if (e.keyCode === 27) {
            dispatch.initiatives.viewUserModalOpen(false);
            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            await dispatch.initiatives.showResourecePane(null);


            if (selectedDataByIdObj && !selectedActivityDataObj && !selectedPlaybookData) {

                dispatch.initiatives.initiativeAggangementPane(null);
                dispatch.initiatives.setIdToCenterPosition(null);
            } else if (selectedPlaybookData) {

            } else if (selectedActivityDataObj) {

                dispatch.initiatives.setIdToCenterPosition(null);
                dispatch.createPack.activityUniqueIdSet(null)
                dispatch.initiatives.setSelectedActivityData({});
            }
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.keyPress, false);
    }

    render() {
        const { resourcePaneFlag, splitAtSize, loadingDeleteInitiative } = this.props
        if (this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'Member') {
            return null
        }

        return (
            <SplitContainer

                orientation="vertical"
                minSize="10%"
                maxSize={['50%', null]}
                fillSides={[true, true]}
                collapsible={[true, false]}
                defaultSplitAt="25%"
                resizeProxy={true}
                onKeyDown={this.keyPress}
                collapsedIndex={this.state.collapsedBrowserPaneIndex}
                splitAt={this.state.browserPaneSplit}
                onResize={(browserPaneSplit) => {
                    if (Number(browserPaneSplit.replace("%", "")) < 11) {
                        this.setState({ collapsedBrowserPaneIndex: 0 })
                    } else {
                        this.setState({ browserPaneSplit })
                    }
                }}
                onExpand={() => {
                    this.setState({
                        collapsedBrowserPaneIndex: null,
                        browserPaneSplit: "25%"
                    })
                }}
                onCollapse={(index) => {
                    this.setState({
                        collapsedBrowserPaneIndex: index,
                        browserPaneSplit: "25%"
                    })
                }}
            >
                <SplitContainer
                    orientation="horizontal"
                    minSize="10%"
                    collapsible={[false, true]}
                    defaultSplitAt="75%">
                    <SplitContainer.Side className="Split-BrowserPane">
                        <InitiativeTree   {...this.props} />
                    </SplitContainer.Side>
                    <SplitContainer.Side >
                        <HelpComponent className="Split-HelpPane " />
                    </SplitContainer.Side>
                </SplitContainer>
                <SplitContainer
                    orientation="horizontal"
                    splitAt={resourcePaneFlag && splitAtSize ? splitAtSize : "100%"}
                    fillSides={[true, true]}
                    minSize={["0%", "0%"]}
                    maxSize={[null, '81%']}
                    collapsible={[true, true]}
                    locked={resourcePaneFlag === null}
                    resizeProxy={true}
                    collapsedIndex={this.props.collapsedResourcePaneIndexTemp === 1 || this.props.collapsedResourcePaneIndexTemp === 0 ? this.state.collapsedResourcePaneIndex : this.props.collapsedResourcePaneIndexTemp}
                    onResize={(splitAt) => {
                        if (Number(splitAt.replace("%", "")) < 30) {
                            this.setState({ collapsedResourcePaneIndex: 0 })
                            dispatch.app.setCollapsedResourcePaneIndexTemp(0)
                        } else if (Number(splitAt.replace("%", "")) > 80) {
                            this.setState({ collapsedResourcePaneIndex: 1 })
                            dispatch.app.setCollapsedResourcePaneIndexTemp(1)
                        } else {
                            dispatch.initiatives.splitAt(splitAt)
                        }
                    }}
                    onExpand={() => {
                        this.setState({ collapsedResourcePaneIndex: null })
                        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                        dispatch.initiatives.splitAt("60%")
                    }}
                    onCollapse={(index) => {
                        this.setState({ collapsedResourcePaneIndex: index })
                        dispatch.app.setCollapsedResourcePaneIndexTemp(index)
                    }}
                >
                    <SplitContainer.Side className="Split-DesignerPane" >

                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in" render={() => (<DesignerIndex  {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/:status" render={() => (<DesignerIndex  {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/:status/selectPlaybook" render={() => (<SelectePlaybook {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/:status/basicInfo" render={() => (<BasicInfo {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/:status/basicInfo/:initiativeId" render={() => (<BasicInfo {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/:status/addAdditionalInfo/:initiativeId" render={() => (<ServeyMetaDataForm {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/:status/teamMapping/:initiativeId" render={() => (<TeamMapping {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/:status/integration/:initiativeId" render={() => <Integration {...this.props} />} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/:status/finalize/:initiativeId" render={() => <Finalize {...this.props} />} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/:status/review/:initiativeId" render={() => <Review {...this.props} />} />
                        <Route path="/app/:accountId/_ws/:workspaceId/_in/:status/configureActivity/:initiativeId" render={() => (<ConfigureActivity {...this.props} />)} />

                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/start/:status/Progress/:initiativeId" render={() => (<Progress {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/start/:status/additionalInfo/:initiativeId" render={() => (<AdditioanlInformation {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/start/:status/Sequence/:initiativeId" render={() => (<Sequence {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/start/:status/Teams/:initiativeId" render={() => (<Teams {...this.props} />)} />
                        <Route exact path="/app/:accountId/_ws/:workspaceId/_in/start/:status/Timeline/:initiativeId" render={() => (<Timeline {...this.props} />)} />

                        <LoadingComponent active={loadingDeleteInitiative} message="Deleting Initiative..." />
                        <LoadingComponent active={this.props.loadingInitiativesData} message="Fetching Initiatives" />
                        <LoadingComponent active={this.props.loadingStartInitiative} message="Setting up initiative" />

                    </SplitContainer.Side>

                    <SplitContainer.Side className="Split-ResourcePane" >
                        <ReactResizeDetector handleWidth handleHeight onResize={this.onResize}>
                            {this.props.activeTab !== "myactivities" ? <ResourcePaneIndex {...this.props} /> : ""}
                        </ReactResizeDetector>
                    </SplitContainer.Side>
                </SplitContainer>
            </SplitContainer >

        );
    }
}


function mapStateToProps(state) {

    return {
        resourcePaneFlag: state.initiatives.resourcePaneFlag,
        selectedDataById: state.initiatives.selectedDataById,
        selectedActivityData: state.initiatives.selectedActivityData,
        splitAtSize: state.initiatives.splitAtSize,
        selectedOrganisation: state.app.selectedOrganisation,
        teamList: state.initiatives.teamList,
        initiativeError: state.initiatives.initiativeError,
        routeParams: state.app.routeParams,
        selectedContent: state.content.selectedContent,

        /**copied from configureactivity */
        initiativeId: state.initiatives.initiativeId,
        isAddActivityModalOpen: state.initiatives.isAddActivityModalOpen,
        isAddPhaseModalOpen: state.initiatives.isAddPhaseModalOpen,
        isDurationSet: state.initiatives.isDurationSet,
        milestoneDependentActivity: state.initiatives.milestoneDependentActivity,
        leafActivity: state.initiatives.leafActivity,
        componentDesignerDimension: state.initiatives.componentDesignerDimension,
        setUniqueId: state.initiatives.setUniqueId,
        enableDependencyIcon: state.lifeCycle.enableDependencyIcon,
        user: state.app.user,
        RaciUserList: state.initiatives.RaciUserList,
        newActivityObj: state.initiatives.newActivityObj,
        addPeerBtnStatus: state.initiatives.addPeerBtnStatus,
        loadingDeleteInitiative: state.loading.effects.initiatives.removeInitiative && state.loading.models.initiatives,

        /**copied from Basic Info */
        selectedPlaybookData: state.initiatives.selectedPlaybookData,
        validateInitiativeName: state.initiatives.validateInitiativeName,
        loadingcreateInitiative: state.loading.effects.initiatives.createInitiative && state.loading.models.initiatives,
        buttonStatus: state.initiatives.buttonStatus,
        pageNotFound: state.initiatives.pageNotFound,
        loadingDataById: state.loading.effects.initiatives.getInDesignInitiativeDetailsById && state.loading.models.initiatives,

        /**copied from progress */
        position: state.initiatives.position,
        arrangementPaneTab: state.initiatives.arrangementPaneTab,
        activityRACIUsers: state.initiatives.activityRACIUsers,
        activeTab: state.initiatives.activeTab,
        associatedTeams: state.initiatives.associatedTeams,
        loadingActiveDataById: state.loading.effects.initiatives.getActiveInitiativeDetailsById && state.loading.models.initiatives,
        loadingCommunityWiseActivities: state.loading.effects.initiatives.getCommunityWiseActivities && state.loading.models.initiatives,
        teamLevelDetails: state.initiatives.teamLevelDetails,
        raciFilterProperties: state.initiatives.raciFilterProperties,
        advancedFilterProperties: state.initiatives.advancedFilterProperties,
        defaultDateFormat: state.app.defaultDateFormat,
        currentContext: state.app.currentContext,
        fetchingActivities: state.loading.effects.initiatives.getAllActivities,
        sequenceViewPosition: state.initiatives.sequenceViewPosition,
        teamViewPosition: state.initiatives.teamViewPosition,
        raciCount: state.initiatives.raciCount,


        //Copied from initiative Index
        loadingInitiativesData: state.loading.effects.initiatives.getInitiatives && state.loading.models.initiatives,
        intitiativeData: state.initiatives.intitiativeData,
        loadingSelectedInitiative: state.loading.effects.initiatives.getActiveInitiativeDetailsById,
        deleteInitiativeLoading: state.loading.effects.initiatives.removeInitiative,

        /**copied from Review.jsx */
        loadingStartInitiative: state.loading.effects.initiatives.startInitiative && state.loading.models.initiatives,
        initiativeOwnerDetails: state.initiatives.initiativeOwnerDetails,
        playbookOwnerDetails: state.initiatives.playbookOwnerDetails,

        /**copied from teammapping.jsx */
        nodes: state.initiatives.nodes,
        selectedPracticeFlowCommunity: state.initiatives.selectedPracticeFlowCommunity,
        loaderStatus: state.initiatives.loaderStatus,
        intitiativeCountData: state.initiatives.intitiativeCountData,
        baseCategoriesArr: state.lifeCycle.baseCategoriesArr,
        loadingPacks: state.loading.models.initiatives,
        loadingInitiativesCount: state.loading.effects.initiatives.getinitiativesCount,

        /**copied from selectplaybok */
        loadingPlaybooksData: state.loading.effects.initiatives.getPublishedPractices,
        practiceData: state.initiatives.practiceData,
        searchedPracticeData: state.initiatives.searchedPracticeData,
        loadingPracticeDataById: state.loading.effects.initiatives.getPracticeById && state.loading.models.initiatives,

        /** copied from resourcepane index */
        suborgDetails: state.initiatives.suborgDetails,
        invitations: state.invite.invitations,
        subOrgInvitaions: state.initiatives.subOrgInvitaions,
        isPlaybookInvitationModalOpen: state.lifeCycle.isPlaybookInvitationModalOpen,
        isEnableDependencyOpen: state.initiatives.isEnableDependencyOpen,
        currentNote: state.initiatives.currentNote,
        activeStatus: state.initiatives.activeStatus,
        collapsedResourcePaneIndexTemp: state.app.collapsedResourcePaneIndexTemp,
        activityActions: state.initiatives.activityActions,
        publishedContent: state.createPack.publishedContent,
        envData: state.app.envData,
        searchUserArr: state.invite.searchUserArr,
        searchInviteUserArr: state.invite.searchInviteUserArr,
        organizationsMap: state.initiatives.organizationsMap,
        communitiesMembersMap: state.initiatives.communitiesMembersMap,
        loadingSingleActivityData: state.loading.effects.initiatives.getSelectedActivityDetails && state.loading.models.initiatives,
        accessToken: state.login.accessToken,
        selectedAccount: state.app.selectedAccount,
        sortingFlag: state.initiatives.sortingFlag,
        loadingUpdateInitiativeActivities: state.loading.effects.initiatives.updateInitiativeActivities && state.loading.models.initiatives,
        loadingUpdateMemberActivities: state.loading.effects.initiatives.updateMemberActivities && state.loading.models.initiatives,
        allCategoryList: state.categories.allCategoryList,
        copyActivityLoader: state.initiatives.copyActivityLoader,
        currentOrganization: state.organizationTab.currentOrganization, // This change is made for KLM-8953
        currentPathValue:state.initiatives.currentPathValue,
        childCommunities: state.initiatives.childCommunities,
        initiativeActivityActions: state.initiatives.initiativeActivityActions,
        updatedActivity: state.initiatives.updatedActivity,
    };
}

const connectedInitiativesDesignerPage = connect(mapStateToProps)(Initiatives);
export { connectedInitiativesDesignerPage as Initiatives };
